import type { AllRouteEndpoints } from "../routeTypes";
export const appsMultiLanguageSettingsUpdateLocaleCacheKeys: AllRouteEndpoints[] = [
  "/apps/multi_language_settings/get_locales",
];
